import { render, staticRenderFns } from "./IconRemoveAction.vue?vue&type=template&id=34b8b08f&"
import script from "./IconRemoveAction.vue?vue&type=script&lang=ts&"
export * from "./IconRemoveAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports